const StyleProperties = {
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    BORDER_COLOR: 'borderColor',
    BACKGROUND_COLOR: 'backgroundColor',
    FOREGROUND_COLOR: 'foregroundColor',
    COLOR: 'color',
    COLOR_SCHEME: 'colorScheme'
};

export default StyleProperties;
